import { render, staticRenderFns } from "./car_team_page.vue?vue&type=template&id=95e71fd2&scoped=true"
import script from "./car_team_page.vue?vue&type=script&lang=js"
export * from "./car_team_page.vue?vue&type=script&lang=js"
import style0 from "./car_team_page.vue?vue&type=style&index=0&id=95e71fd2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95e71fd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/riverlei/project/java/bgyy-project/front-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('95e71fd2')) {
      api.createRecord('95e71fd2', component.options)
    } else {
      api.reload('95e71fd2', component.options)
    }
    module.hot.accept("./car_team_page.vue?vue&type=template&id=95e71fd2&scoped=true", function () {
      api.rerender('95e71fd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/logistics_hongde/car_team/car_team_page.vue"
export default component.exports